import { cl, replaceBodyClassName, replaceBodyClassNameTransition } from '@/js/utils';
import type { Core } from '@barba/core/dist/core/src/src/core';
import type { Trigger, Link } from '@barba/core/dist/core/src/src/defs';
import { bus } from '@/js/bus';
import select from 'dom-select';

export let barba: Core | null = null;
export let busy: boolean = false;

let lastScrollY = 0;

export function barbaInit() {
  if (!select('.barba-wrapper')) {
    return;
  }
  import('@barba/core').then(({ default: brb }) => {
    cl('.barba-container').remove('to-load');
    barba = brb;
    if (!barba) return;

    barba.init({
      timeout: 4000,
      debug: false,
      preventRunning: true,
      requestError: () => {
        return true;
      },
      prevent: ({ href }: any) => {
        return (
          href &&
          (href.indexOf('/actions/') > -1 || !!href.match(/\.(xls|xlsx|doc|docx|pdf)$/)?.length)
        );
      },
      transitions: [],
    });

    bus.emit('barba_ready', barba);

    barba.hooks.before(() => {
      setBusy(true);
      lockScrollArea();
    });

    barba.hooks.leave((data) => {
      if (!data) return;
      // @ts-ignore
      if (!data.trigger?.classList?.contains('breadcrumb')) {
        window.breadCrumbScroll = 0;
      }
      bus.emit('barba_leave', data);
    });

    const themeMeta = select('meta[name="theme-color"]');
    barba.hooks.enter((data) => {
      if (!data) return;
      bus.emit('barba_enter', data);
      replaceBodyClassName(data.next.namespace);

      if (themeMeta) {
        themeMeta.setAttribute('content', data.next.container.getAttribute('data-theme') || '#FFFFFF');
      }

      if (data.next.container.hasAttribute('data-has-banner')) {
        cl(document.body).add('has-banner');
      } else {
        cl(document.body).remove('has-banner');
      }

      if (data.next.container.hasAttribute('data-no-ticker')) {
        cl(document.body).add('no-ticker');
      } else {
        cl(document.body).remove('no-ticker');
      }
    });

    barba.hooks.after((data) => {
      setBusy(false);
      if (!data) return;
      if (!data.trigger || (data.trigger && !(data.trigger as Link)?.hasAttribute('data-tab'))) {
        requestAnimationFrame(() => {
          window.scrollTo(0, 0);
        })
      }
      bus.emit('cancel');
      lockScrollArea(false);
      replaceBodyClassNameTransition('', true);
      cl(data.next.container).remove('to-load');
      bus.emit('barba_after', data);

      if (typeof data.trigger === 'object' && data.trigger.getAttribute('href')) {
        const hash = (data.trigger.getAttribute('href') || '').split('#')?.[1];
        const el = hash ? select(`#${hash}`) : null;
        if (el) {
          const { top } = el.getBoundingClientRect();
          if (top > 0) {
            requestAnimationFrame(() => {
              window.scrollTo({
                top,
                left: 0,
                behavior: 'smooth',
              });
            })
          }
        }
      }
    });
  });
}

function lockScrollArea(lock = true) {
  if (lock) {
    document.body.style.setProperty('--scroll-y', `-${window.scrollY}px`);
  } else {
    document.body.style.removeProperty('--scroll-y');
  }
}

export function getCurrentNamespace() {
  const currentCont = select('[data-barba="container"]');
  return currentCont?.getAttribute('data-barba-namespace') || '';
}

export function go({
  url,
  trigger = 'barba',
  clear = false,
}: {
  url: string;
  trigger?: string;
  clear?: boolean;
}) {
  if (barba) {
    if (clear) {
      barba.cache.delete(url);
    }
    barba.go(url, trigger as Trigger).then();
  }
}

export function goBack(url = '') {
  const segments = window.location.href.split('/')
  const prev = barba?.history?.previous?.url || url || '/';
  if (prev) {
    // go({ url: prev })
    window.history.back();
  }
}

export function replaceHistory(url: string) {
  if (barba) {
    barba.history.add(url, 'barba');
  }
}

export function setBusy(b: boolean) {
  busy = b;
  bus.emit('busy', b);
  if (b) {
    cl(document.body).add('is-busy');
  } else {
    cl(document.body).remove('is-busy');
  }
}
